import { Module } from "vuex";
import { RootState } from "../types";
import { SchoolState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: SchoolState = {
  initial: null,
  salesToken: null
};

const namespaced: boolean = true;

export const school: Module<SchoolState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
